import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Buenos Aires',
  text: 'En una semana mis hijos dejaron de pedirme el celular a cada rato. El sistema de misiones los enganchó desde el primer día. Vale cada peso.'
}, {
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Córdoba · Mamá de 3',
  text: 'Nunca pensé que iba a poder cocinar en paz. Con el pack armado tengo 30 minutos reales todos los días. Los chicos lo piden solos.'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  location: 'Rosario',
  text: 'El tablero de control familiar fue lo que más nos cambió la dinámica en casa. Mi hijo pide hacer las actividades para ganar sus estrellas.'
}];
export function Testimonials() {
  return <section className="py-12 px-4 bg-zinc-950" data-id="element-227" data-mp="v9oppmy09m41">
      <div className="max-w-6xl mx-auto" data-id="element-228" data-mp="v7c9be7wbjt3">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-229" data-mp="q9u0roxsj6lm">
          {testimonials.map((t, i) => <div key={i} className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 relative" data-id="element-230" data-mp="h5f19rwoi73u" data-mpi={i}>
              <div className="flex items-center gap-1 text-yellow-400 mb-4" data-id="element-231" data-mp="m6m7vnn3508x">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-232" data-mp="7a4zn5a701ql" data-mpi={j} />)}
              </div>
              <p className="text-zinc-300 text-lg italic mb-6" data-id="element-233" data-mp="c8oiuxxeizf9">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-234" data-mp="zx7r5dggbc7c">
                <div className="w-10 h-10 rounded-full bg-yellow-400/20 text-yellow-400 flex items-center justify-center font-bold" data-id="element-235" data-mp="14vskqu176xmt">
                  {t.initials}
                </div>
                <div className="text-sm text-zinc-500" data-id="element-236" data-mp="v57mj7pfrv4f">
                  — {t.name}, {t.location}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}